import axios, { AxiosInstance } from 'axios'
import config from '../../config'

const client: AxiosInstance = axios.create({
  baseURL: config.CUSTOMER_BFF_HOST,
  timeout: 30000,
})

export default client
